import axios from 'config/axios';
import Swal from 'sweetalert2';
import env from 'config/env';
import React, { useEffect } from 'react';
import Tables from '../../components/material/Tables';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
// import _ from 'lodash';
//import Resdata from './Resdata.json'
import Pagination from '../../components/boostrap/Pagination';
import PageLimit from '../../components/boostrap/PageLimit';
import 'semantic-ui-css/semantic.min.css';
import { Item } from 'semantic-ui-react';

import LoginModal from 'components/boostrap/model/addModel';

import moment from 'moment';
import Edit from '../../components/ImageView/ImageView';
// import { Datepicker } from 'components/Datepicker';
// import Checkbox from '@material-ui/core/Checkbox';
// import FormControlLabel from '@material-ui/core/FormControlLabel';

// import { Tab } from '@material-ui/core';
import Box from '@material-ui/core/Box';
// import Tabs from '@material-ui/core/Tabs';
// import Typography from '@material-ui/core/Typography';

interface SortingI {
  orderName: string;
  order_by: string;
}
interface MetaI {
  from: number;
  to: number;
  total: number;
}
interface ColHeaders {
  id: string;
  description: string;
  value: string;
  active: boolean;
}
//item styles

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    option: {
      padding: '5px 0',
    },
    ul: {
      '& .MuiList-root': {
        position: 'fixed',
      },
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
    conf: {
      border: '0',
      borderRadius: '.25em',
      background: 'initial',
      backgroundColor: '#e64942',
      color: '#fff',
      fontSize: '1.0625em',
      margin: '.3125em',
      padding: '.625em 1.1em',
      boxShadow: 'none',
    },
    yesConfirm: {
      backgroundColor: '#e3342f !important',
      fontSize: '13px !important',
      fontWeight: 400,
      paddingTop: '12px',
      paddingLeft: '11px',
      paddingRight: '11px',
      paddingBottom: '9px',
      borderColor: '#e3342f !important',
    },
    noCancel: {
      backgroundColor: '#888',
      fontSize: '13px !important',
      fontWeight: 400,
      paddingTop: '12px',
      paddingLeft: '11px',
      paddingRight: '11px',
      paddingBottom: '9px',
    },
  }),
);

const App = props => {
  const classes = useStyles();
  const [data, setdata] = React.useState<any>([]);
  const [dataDep] = React.useState<any>([]);
  let fr = new Date();
  fr.setDate(fr.getDate() - 90);
  // const fromDateRef = React.useRef();
  // const toDateRef = React.useRef();
  const [showLogin, setShowLogin] = React.useState(false);
  const [editopen, setEditOpen] = React.useState(false);
  const [frchange, setfrchange] = React.useState<boolean>(false);
  const [trchange, settrchange] = React.useState<boolean>(false);
  const [holdSearch, setHoldSearch] = React.useState<boolean>(true);
  // const [reArranged, setArranged] = React.useState([]);
  // const [delData, setDeldata] = React.useState([]);
  const [clickData, setClickData] = React.useState<any>([]);
  const [page, setpage] = React.useState<number>(1);
  const [perPage, setperPage] = React.useState<number>(50);
  const [pages, setPages] = React.useState<number[]>([]);
  const [mount, setMount] = React.useState(false);
  const [load, setLoad] = React.useState(false);
  const [searchEvent, setsearchEvent] = React.useState<string>('');
  const [printnow, setprintnow] = React.useState(false);
  const [type, setType] = React.useState<any>(0);
  const [lastpage, setlastPage] = React.useState<number>(0);
  const [reRender, setRerender] = React.useState<number>(1000);
  const [reRend, setRerend] = React.useState<number>(1000);
  const [forcereRender, setForceRerender] = React.useState<number>(1000);
  // const [Text, SetText] = React.useState<string>('Select All');
  const [checked, setChecked] = React.useState(false);
  const [sorting, setSorting] = React.useState<SortingI>({
    orderName: 'rno',
    order_by: 'desc',
  });
  // const [rangeEnabled, setrangeEnabled] = React.useState(true);
  // const [tMaxdate, setTMaxdate] = React.useState<Date>(new Date());
  const [loading, setLoading] = React.useState<boolean>(false);

  const [colHeaders, setColHeaders] = React.useState<ColHeaders[]>([
    {
      id: '1',
      description: 'Invoice File Id',
      value: 'invoiceId',
      active: true,
    },
    { id: '2', description: 'Vendor Name', value: 'vendorName', active: true },
    {
      id: '3',
      description: 'Invoice Receipt Date',
      value: 'date',
      active: true,
    },
    { id: '4', description: 'Total', value: 'total', active: true },
    {
      id: '5',
      description: 'Image Count',
      value: 'imageCount',
      active: true,
    },
  ]);

  const [fDate, setFdate] = React.useState<Date>(fr);

  const [tDate] = React.useState<Date>(new Date());
  const [meta, setMeta] = React.useState<MetaI>({
    from: 0,
    to: 0,
    total: 0,
  });

  const countPages = React.useCallback(
    (total: number, current_page: number) => {
      setPages([]);
      let lastPage = Math.ceil(total / perPage);
      setlastPage(lastPage);
      var start = current_page - 4;

      if (start < 2) {
        start = 1;
      }
      var end = current_page + 4;

      if (end > lastPage) {
        end = lastPage;
      }

      var p = [];
      for (let i = start; i < end; i++) {
        p.push(i);
        setPages(p);
      }
    },
    [perPage],
  );

  // const autoDateselect = date => {
  //   let toDate = new Date(date);
  //   toDate.setDate(toDate.getDate() + 90);
  //   let min = new Date();

  //   toDate > min ? setTdate(min) : setTdate(toDate);
  //   toDate > min ? setTMaxdate(min) : setTMaxdate(toDate);
  //   toDate > min ? setTMaxdate(min) : setTMaxdate(toDate);
  //   setrangeEnabled(false);
  // };

  const setSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setsearchEvent(e.target.value);
  };
  const setfromDate = React.useCallback(
    date => {
      let fromDatenow = fDate;

      fromDatenow > date ? setFdate(date) : setFdate(fDate);
    },
    [fDate],
  );

  // check box bulk del
  // const Buldel = row => {
  //   // console.log(delData ,"del data")

  //   disDelete(delData);
  // };

  // const disDelete = row => {
  //   var myhtml = document.createElement('div');
  //   myhtml.setAttribute('id', 'Div1');
  //   myhtml.innerHTML =
  //     "<div class='row text-center' style='width:inherit;align-content: center;'><h2 class='swal-text text-center' style='margin-left: 5%;margin-top: 0px;font-size: 23px;'><b>You Are About To Delete Selected Notification Types?</b></h2> <br/><div class='swal-text' style='margin-left: 29%;padding-bottom: 10px;font-size: 18px;margin-top: 10px;'>Click Yes To Delete</div><br/><div  style='width:88%;'><input type='password' id='password' class='form-short' style='width:96%!important;height: 37px;margin-left: 15px;' placeholder='Password' autocomplete='off'/></div><div  style='margin-left: 0px;'><button  class='input-group-text' style='width:41px;height: 37px;' onclick='bsd()' ><div onclick='asd()'><i class='zmdi zmdi-eye' id='zmdi' onclick='asd()' ></i></div></div></button></div></div>";
  //   var g = document.createElement('script');
  //   var s = document.getElementsByTagName('script')[0];
  //   g.text =
  //     'function asd(){var y=document.getElementById("zmdi");var x=document.getElementById("password"); if(x.type=="password"){x.type="text";y.className="zmdi zmdi-close";y.style="margin-left:2px;"}else{x.type="password";y.className="zmdi zmdi-eye";y.style="margin-left:0px"}};function bsd(){var y=document.getElementById("zmdi");var x=document.getElementById("password"); if(x.type=="password"){x.type="text";y.className="zmdi zmdi-close";y.style="margin-left:2px;"}else{x.type="password";y.className="zmdi zmdi-eye";y.style="margin-left:0px"}};';

  //   s.parentNode.insertBefore(g, s);

  //   Swal.fire({
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonText: 'Yes,Delete!',
  //     cancelButtonText: 'No,Cancel!',
  //     reverseButtons: true,
  //     customClass: {
  //       confirmButton: classes.yesConfirm,
  //       cancelButton: classes.noCancel,
  //     },
  //     html: myhtml,
  //   }).then(result => {
  //     if (result.isConfirmed) {
  //       // @ts-ignore
  //       let inputval = document.getElementById('password').value;
  //       var url = window.location.hostname;
  //       if (inputval !== '') {
  //         axios
  //           .post(`https://${url}/pass-check`, {
  //             pass: inputval,
  //           })
  //           .then(res => {
  //             let resp: any = res;
  //             if (resp.success) {
  //               const deldataEdited = _.map(delData, 'uuid');
  //               const finalEditDelArry = { uuids: deldataEdited };
  //               deleteDa(finalEditDelArry);
  //             } else {
  //               Swal.fire({
  //                 icon: 'error',
  //                 title: 'Failed!',
  //                 text: 'Please Check Your Password',
  //                 customClass: {
  //                   confirmButton: classes.conf,
  //                 },
  //               });
  //             }
  //           })
  //           .catch(res => {
  //             Swal.fire({
  //               icon: 'error',
  //               title: 'Failed!',
  //               text: 'Please Check Your Password',
  //               buttonsStyling: false,
  //               customClass: {
  //                 confirmButton: classes.conf,
  //               },
  //             });
  //           });
  //       } else {
  //         Swal.fire({
  //           icon: 'error',
  //           title: 'Failed!',
  //           text: 'Please Check Your Password',
  //           buttonsStyling: false,
  //           customClass: {
  //             confirmButton: classes.conf,
  //           },
  //         });
  //       }
  //     }
  //   });
  // };

  // const deleteDa = async bulkDel => {

  //   axios.defaults.withCredentials = true;
  //   await axios({
  //     method: 'delete',
  //     url: `${env.apiURL}/invoice`,
  //     data: bulkDel,
  //   })
  //     .then(error => {
  //       Swal.fire({
  //         position: 'center',
  //         icon: 'success',
  //         title: 'Success',
  //         text: 'Deleted!Successfully ',
  //         confirmButtonColor: '#2778c4',
  //         showConfirmButton: true,
  //       });
  //       setLoad(false);
  //     })
  //     .catch(error => {
  //       Swal.fire({
  //         icon: 'error',
  //         title: 'Sorry..!',
  //         text: error.message,
  //       });
  //     });
  // };

  const filterData = React.useCallback(async (e: string, r: string) => {
    var from = moment(e).format('YYYY-MM-DD');
    var to = moment(r).format('YYYY-MM-DD');
    await axios
      .get(
        `${env.apiURL}/exception-report/other-filter?from=${from}&to=${to}`,
        {},
      )
      .then(res => {})
      .catch(error => {});
  }, []);

  const getData = React.useCallback(
    async typ => {
      setLoading(true);

      // setdata(tdata);
      setChecked(false);

      // var from = moment(fDate).format('YYYY-MM-DD');
      // var to = moment(tDate).format('YYYY-MM-DD');
      //console.log(type,"type load32")

      await axios
        .get(
          `${env.apiURL}/invoice?per_page=${perPage}&order_by=${sorting.orderName},${sorting.order_by}&search=${searchEvent}`,
        )
        .then(res => {
          let response: any = res;

          let tempData = [];
          response.data.forEach((item: any, index: number) => {
            tempData[index] = {
              invoiceId: item.invoice_file_id,
              imageUri: item.images,
              total: item.total,
              subtotal: item.subtotal,
              tax: item.tax,
              s3path: item.s3_path,
              jsonData: item.json_data ? JSON.parse(item.json_data) : [],
              invoiceReceiptId: item.invoice_receipt_id,
              date: item.invoice_receipt_date,
              vendorName: item.vendor_name,
              inv_status: item.inv_status,
              summary_id: item.summary_id,
              imageCount: item.images_count,
            };
          });
          setdata(tempData);

          countPages(response.total, page);
          setMeta({
            ...meta,
            from: response.from,
            total: response.total,
            to: response.to,
          });

          setLoading(false);
        })
        .catch(error => {
    
          Swal.fire({
            icon: 'error',
            title: 'Sorry',
            text: error.message,
          });

        //   let response: any = Resdata;

        //   let tempData = [];
        //   response.data.forEach((item:any, index:number) => {
        //     tempData[index] = {
        //       invoiceId: item.invoice_file_id,
        //       imageUri : item.images,
        //       total: item.total,
        //       subtotal: item.subtotal,
        //       tax: item.tax,
        //       s3path: item.s3_path,
        //       jsonData: item.json_data ? JSON.parse(item.json_data) : [],
        //       invoiceReceiptId: item.invoice_receipt_id,
        //       date: item.invoice_receipt_date,
        //       vendorName: item.vendor_name,
        //       imageCount: item.images_count,
        //       summary_id:item.summary_id,
        //       inv_status:item.inv_status,
        //     }
        //   })
        //   setdata(tempData);
        //   setLoading(false);
       });
    },
    [
      page,
      perPage,
      meta,

      sorting.orderName,
      sorting.order_by,
      searchEvent,
      countPages,
    ],
  );

  const setnewLimit = (pageLimit: number) => {
    setpage(1);
    setperPage(pageLimit);
    setMount(false);

    setLoad(false);
  };

  const setnewPage = (currentPage: number) => {
    setperPage(perPage);
    setpage(currentPage);

    setMount(false);
    setLoad(false);
  };

  const onKeyUpValue = event => {
    if (event.key === 'Enter') {
      getData(event);
    }
  };
  const setnewSort = (SortDta: SortingI) => {
    setSorting(SortDta);
    setMount(false);
    setLoad(false);
  };

  useEffect(() => {
    if (!mount) {
      if (!holdSearch) {
        setHoldSearch(false);
        setRerend(reRend + 1);
        !holdSearch ? setsearchEvent('') : setsearchEvent(searchEvent);
      }
      setRerender(reRender + 1);
      setForceRerender(forcereRender + 12);
      setMount(true);
    }
  }, [
    page,
    fDate,
    tDate,
    getData,
    filterData,
    mount,
    perPage,
    setRerender,
    forcereRender,
    reRender,
    holdSearch,
    reRend,
    searchEvent,
  ]);

  useEffect(() => {
    setType(type);
  }, [type]);

  useEffect(() => {
    if (!frchange) {
      setfromDate(tDate);
      setfrchange(true);
    }

    if (!trchange) {
      settrchange(true);
    }
  }, [fDate, frchange, setfromDate, tDate, trchange]);
  useEffect(() => {
    if (!load) {
      getData(type);

      setLoad(true);
    }
  }, [load, fDate, type, tDate, getData]);

  const deleteData = async (sup_code: number) => {
    axios.defaults.withCredentials = true;

    await axios({
      method: 'delete',
      url: `${env.apiURL}/supplier_manager/delete`,
      data: { sup_code },
    })
      .then(res => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Success',
          text: 'Deleted!Successfully ',
          confirmButtonColor: '#2778c4',
          showConfirmButton: true,
        });
        setLoad(false);
      })
      .catch(error => {
        Swal.fire({
          icon: 'error',
          title: 'Cannot Delete image',
          text: error.message,
        });
        setLoading(false);
      });
  };
  return (
    <div className="App">
      <div className={classes.root}>
        <Box style={{ width: '100%' }}>
          <>
            <Paper
              className={classes.paper}
              elevation={0}
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
              }}>
              <Grid
                container
                xs={12}
                spacing={1}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}>
                <Grid item xs={5}>
                  <Item>
                    <div className="input-group rounded">
                      <input
                        type="search"
                        style={{
                          width: '100%',
                        }}
                        className="form-control rounded"
                        key={reRend + 'rere'}
                        onChange={setSearch}
                        placeholder="Search ...."
                        onKeyUp={onKeyUpValue}
                      />
                    </div>
                  </Item>
                </Grid>

                <Grid
                  item
                  xs={1}
                  style={{
                    paddingRight: '0px',
                  }}>
                  <Item>
                    <button
                      id={'tst'}
                      style={{
                        minWidth: '90%',
                        minHeight: '33px',
                        borderRadius: '4px',
                        backgroundColor: 'rgb(4, 190, 91)',
                        color: 'white',

                        fontSize: '12.5px',
                      }}
                      onClick={() => {
                        getData(type);
                      }}>
                      Search
                    </button>
                  </Item>
                </Grid>
              </Grid>
            </Paper>
            <Grid>
              <Grid item xs={12} sm={12} lg={12} md={12} className="m-2 ">
                <LoginModal
                  depData={dataDep}
                  show={showLogin}
                  close={() => setShowLogin(false)}
                />

                <Edit
                  depData={dataDep}
                  row={clickData}
                  setMount={setLoad}
                  rowReset={setClickData}
                  editopen={editopen}
                  setEditOpen={setEditOpen}
                />
                <br></br>
                <Paper className={classes.paper} elevation={0}>
                  <div>
                    {loading ? (
                      <div className="spinner">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                      </div>
                    ) : (
                      <Tables
                        data={data}
                        depData={dataDep}
                        setClickData={setClickData}
                        setEditOpen={setEditOpen}
                        setSorting={setnewSort}
                        pageNumber={page}
                        checked={checked}
                        getData={getData}
                        sorting={sorting}
                        deleteData={deleteData}
                        colHeaders={colHeaders}
                        setColHeaders={setColHeaders}
                        status=""
                        setLoad={setLoad}
                        fdate={fDate}
                        tdate={tDate}
                        newaction={false}
                        // arrangeData={setArranged}
                        // bulkDel={setDeldata}
                        printnow={printnow}
                        setprintnow={setprintnow}
                      />
                    )}
                  </div>

                  <Grid
                    container
                    item
                    style={{
                      backgroundColor: '#f7f7f7',
                      borderTop: '1px solid rgba(0, 0, 0, 0.125)',
                      paddingTop: '10px',
                      paddingLeft: '8px',
                      paddingBottom: '10px',
                    }}>
                    <Grid xs={3} lg={1} md={2} sm={3}>
                      <PageLimit
                        changePage={setnewLimit}
                        perPage={perPage}
                        key={reRender + 'limit'}
                      />
                    </Grid>
                    <Grid
                      xs={2}
                      lg={2}
                      md={3}
                      sm={3}
                      style={{ marginTop: '8px' }}>
                      {meta.from} - {meta.to} of {meta.total} Items
                    </Grid>

                    <Grid xs={12} lg={9} md={7} sm={12}>
                      <Pagination
                        lastPage={lastpage}
                        pages={pages}
                        page={page}
                        changePageNumber={setnewPage}
                      />
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
            </Grid>
          </>
        </Box>
      </div>
    </div>
  );
};
export default App;
